// extracted by mini-css-extract-plugin
export default {"container":"BrownCards_container_UcuZ4","cards":"BrownCards_cards_mL91H","card":"BrownCards_card_VrhMO","title":"BrownCards_title_D60HG","text":"BrownCards_text_Uz0dH"};